module.exports = __webpack_public_path__ + "img/philipi_stv110.15ce258a.png";